<div class="stepper">
  <!-- Desktop: Single progress line (absolute positioned) -->
  <div class="stepper__progress-line stepper__progress-line--desktop">
    <!-- Active progress indicator -->
    <div
      class="stepper__progress-indicator"
      [style.width.%]="getProgressPercentage()">
    </div>
  </div>

  <!-- Steps container -->
  <div class="stepper__steps">
    @for (step of steps(); track step.number; let i = $index; let isLast = $last) {
      <!-- Step -->
      <div
        class="stepper__step"
        [class.stepper__step--active]="isActive(i)"
        [class.stepper__step--completed]="isCompleted(i)"
        (click)="onStepClick(i)">

        <!-- Step label -->
        <div class="stepper__label">
          {{ getStepLabel(step) | translateLang }}
        </div>

        <!-- Step icon with number -->
        <div class="stepper__icon">
          <span class="stepper__number">{{ step.number }}</span>
        </div>
      </div>

      <!-- Mobile: Line segment between steps -->
      @if (!isLast) {
        <div
          class="stepper__line-segment"
          [class.stepper__line-segment--active]="isCompleted(i)">
        </div>
      }
    }
  </div>
</div>
